import customSelect from "../../helpers/custom-select";
import SimpleScrollbar from 'simple-scrollbar';

export default () => {

	const provinceSelects = document.querySelectorAll('.js-province-select');
	const countrySelects = document.querySelectorAll('.js-country-select');
	const showElementsConst = 7;

	if (countrySelects.length) {
		countrySelects.forEach((select) => {
			const idStartPos = select.id.indexOf('_') + 1;
			const selectId = select.id.slice(idStartPos);
			const pairedSelect = document.querySelector(`#AddressProvince_${selectId}`);

			customSelect({
				select: select,
				dropdownProps: {
					showElements: showElementsConst,
					onOptionSelect: () => {

						let changeEvent = new Event('change');
						select.dispatchEvent(changeEvent);

						if (pairedSelect.firstElementChild) {
							pairedSelect.setAttribute('data-default', pairedSelect.firstElementChild.value);
						}
						else {
							pairedSelect.setAttribute('data-default', '');
						}

						const prevCustormSelect = pairedSelect.parentElement.querySelector('[data-form-select]');
						if (prevCustormSelect) prevCustormSelect.remove();

						if (select.children.length > 0) {
							customSelect({
								select: pairedSelect,
								dropdownProps: {
									showElements: showElementsConst,
								}
							});

							SimpleScrollbar.initEl(pairedSelect.parentElement.querySelector('[data-select-list]'));
						}

					}
				}
			});
		});
	}

	if (provinceSelects.length) {
		provinceSelects.forEach((select) => {
			if (select.children.length > 0) {
				customSelect({
					select: select,
					dropdownProps: {
						showElements: showElementsConst,
					}
				});
			}
		})
	}

	document.querySelectorAll('[data-select-list]').forEach(elem => {
		SimpleScrollbar.initEl(elem);
	});

}